module.exports = __webpack_public_path__ + "static/ae-706722f5405fe01f7697b99cac798cd3.mp3";